<section class="sh-dialog__content">
    <p class="sh-clear-margin-top">{{ messageKey | translate }}</p>
    <sh-action-item [item]="navigationItem$ | async"></sh-action-item>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="button" class="sh-button sh-action-group__item" (click)="submit()">{{ acceptKey | translate }}</button>
    </div>
</footer>
